(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hhh-contact-faq"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initContactFaq() {
    const section = document.querySelector('.hhh-contact-faq');
    if (!section) return;
    const items = section.querySelectorAll('.hhh-contact-faq__item');

    items.forEach(function (item) {
      const summary    = item.querySelector('.hhh-contact-faq__question');
      const answerWrap = item.querySelector('.hhh-contact-faq__answer-wrap');
      const answer     = item.querySelector('.hhh-contact-faq__answer');
      if (!summary || !answerWrap || !answer) return;

      if (item.open) {
        answerWrap.style.maxHeight = answer.scrollHeight + 'px';
        answerWrap.style.opacity   = '1';
      } else {
        answerWrap.style.maxHeight = '0';
        answerWrap.style.opacity   = '0';
      }

      answerWrap.style.transition = 'max-height 340ms cubic-bezier(0.16, 1, 0.3, 1), opacity 260ms ease';

      summary.addEventListener('click', function (e) {
        e.preventDefault();
        const isOpen = item.open;

        if (isOpen) {
          answerWrap.style.maxHeight = '0';
          answerWrap.style.opacity   = '0';
          setTimeout(function () { item.removeAttribute('open'); }, 340);
        } else {
          item.setAttribute('open', '');
          answerWrap.style.maxHeight = answer.scrollHeight + 'px';
          answerWrap.style.opacity   = '1';
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initContactFaq);
  } else {
    initContactFaq();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hhh-contact-topics"] && !Shopify.designMode) return;
  try {
    
(function() {
  function initTopicClick() {
    const cards = document.querySelectorAll('.hhh-contact-topics__card');
    const formSection = document.getElementById('hhh-contact-form-section') || document.querySelector('.hhh-contact');
    const reasonSelect = document.getElementById('hhh-contact-reason');

    cards.forEach(card => {
      card.addEventListener('click', () => {
        const topic = card.dataset.topic;
        if (formSection) {
          formSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
        if (reasonSelect && topic) {
          for (let i = 0; i < reasonSelect.options.length; i++) {
            if (reasonSelect.options[i].text.trim().toLowerCase() === topic.trim().toLowerCase() ||
                reasonSelect.options[i].value.trim().toLowerCase() === topic.trim().toLowerCase()) {
              reasonSelect.selectedIndex = i;
              reasonSelect.dispatchEvent(new Event('change'));
              break;
            }
          }
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTopicClick);
  } else {
    initTopicClick();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hhh-faq"] && !Shopify.designMode) return;
  try {
    
(function () {
  const faqs = document.querySelectorAll('.hhh-faq[data-section-id] .hhh-faq__item');

  faqs.forEach(function (item) {
    const summary    = item.querySelector('.hhh-faq__question');
    const answerWrap = item.querySelector('.hhh-faq__answer-wrap');
    const answer     = item.querySelector('.hhh-faq__answer');
    if (!summary || !answerWrap || !answer) return;

    if (item.open) {
      answerWrap.style.maxHeight = answer.scrollHeight + 'px';
      answerWrap.style.opacity   = '1';
    } else {
      answerWrap.style.maxHeight = '0';
      answerWrap.style.opacity   = '0';
    }

    answerWrap.style.transition = 'max-height 360ms cubic-bezier(0.22, 0.6, 0.36, 1), opacity 280ms ease';

    summary.addEventListener('click', function (e) {
      e.preventDefault();
      const isOpen = item.open;

      document.querySelectorAll('.hhh-faq__item[open]').forEach(function (other) {
        if (other === item) return;
        const ow = other.querySelector('.hhh-faq__answer-wrap');
        if (ow) { ow.style.maxHeight = '0'; ow.style.opacity = '0'; }
        setTimeout(function () { other.removeAttribute('open'); }, 360);
      });

      if (isOpen) {
        answerWrap.style.maxHeight = '0';
        answerWrap.style.opacity   = '0';
        setTimeout(function () { item.removeAttribute('open'); }, 360);
      } else {
        item.setAttribute('open', '');
        answerWrap.style.maxHeight = answer.scrollHeight + 'px';
        answerWrap.style.opacity   = '1';
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
